<div class="mktd" [class.mktd--embedded]="embedded">

    <!-- ═══ TOP HEADER (hidden in embedded mode) ═══ -->
    <header class="mktd__header" *ngIf="!embedded">
        <div class="mktd__header-left">
            <h1 class="mktd__title"><i class="fa-solid fa-bullhorn"></i> Marketing Dashboard</h1>
        </div>
        <div class="mktd__header-right">
            <select [(ngModel)]="defaultCompanyId" class="mktd__company-select" (ngModelChange)="onCompanyChange()">
                <option value="" disabled>Select company</option>
                <option *ngFor="let c of companies" [value]="c.ID">{{ c.Name }}</option>
            </select>
        </div>
    </header>

    <!-- ═══ BODY: SIDEBAR + MAIN ═══ -->
    <div class="mktd__body">

        <!-- Sidebar Navigation -->
        <nav class="mktd__sidebar">
            <button class="mktd__nav-item" [class.mktd__nav-item--active]="activeSection === 'overview'" (click)="setSection('overview')">
                <i class="fa-solid fa-chart-line"></i> <span>Overview</span>
            </button>
            <button class="mktd__nav-item" [class.mktd__nav-item--active]="activeSection === 'content-library'" (click)="setSection('content-library')">
                <i class="fa-solid fa-book-open"></i> <span>Content Library</span>
            </button>
            <button class="mktd__nav-item" [class.mktd__nav-item--active]="activeSection === 'analytics'" (click)="setSection('analytics')">
                <i class="fa-solid fa-chart-bar"></i> <span>Analytics</span>
            </button>
            <button class="mktd__nav-item" [class.mktd__nav-item--active]="activeSection === 'social-queue'" (click)="setSection('social-queue')">
                <i class="fa-brands fa-linkedin"></i> <span>Social Queue</span>
            </button>
        </nav>

        <!-- Main Content -->
        <main class="mktd__main">
            <div *ngIf="isLoading" class="mktd__loading">
                <i class="fa-solid fa-spinner fa-spin"></i> Loading...
            </div>

            <!-- ═══ OVERVIEW ═══ -->
            <div *ngIf="!isLoading && activeSection === 'overview'" class="mktd__section">
                <h2 class="mktd__section-title">Overview</h2>
                <div class="mktd__kpi-grid">
                    <div class="mktd__kpi-card">
                        <div class="mktd__kpi-value">{{ publishedThisWeek }}</div>
                        <div class="mktd__kpi-label">Published This Week</div>
                    </div>
                    <div class="mktd__kpi-card">
                        <div class="mktd__kpi-value">{{ pendingApproval }}</div>
                        <div class="mktd__kpi-label">Pending Approval</div>
                    </div>
                    <div class="mktd__kpi-card">
                        <div class="mktd__kpi-value">{{ activeIntegrations }}</div>
                        <div class="mktd__kpi-label">Active Integrations</div>
                    </div>
                    <div class="mktd__kpi-card mktd__kpi-card--wide">
                        <div class="mktd__kpi-value mktd__kpi-value--sm">{{ topPerformer }}</div>
                        <div class="mktd__kpi-label">Top Performer (Views)</div>
                    </div>
                </div>

                <!-- Recent activity -->
                <h3 class="mktd__subsection-title">Recent Content</h3>
                <div class="mktd__recent-list">
                    <div *ngFor="let b of blogs | slice:0:5" class="mktd__recent-item" (click)="openFlyout('blog', b.ID)">
                        <i class="fa-solid fa-file-lines mktd__recent-icon mktd__recent-icon--blog"></i>
                        <div class="mktd__recent-info">
                            <div class="mktd__recent-title">{{ b.Title }}</div>
                            <div class="mktd__recent-meta">Blog &middot; {{ getStatusName(b.Get('ContentStatusID')) }}</div>
                        </div>
                    </div>
                    <div *ngFor="let sp of socialPosts | slice:0:5" class="mktd__recent-item" (click)="openFlyout('social-post', sp.ID)">
                        <i class="fa-solid fa-share-nodes mktd__recent-icon mktd__recent-icon--social"></i>
                        <div class="mktd__recent-info">
                            <div class="mktd__recent-title">{{ sp.SocialPlatform || 'Social Post' }}</div>
                            <div class="mktd__recent-meta">Social &middot; {{ getStatusName(sp.Get('ContentStatusID')) }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ═══ CONTENT LIBRARY ═══ -->
            <div *ngIf="!isLoading && activeSection === 'content-library'" class="mktd__section">
                <mkt-content-library
                    [blogs]="blogs"
                    [socialPosts]="socialPosts"
                    [newsletters]="newsletters"
                    [contentStatuses]="contentStatuses"
                    [contentTypes]="contentTypes"
                    [socialPlatforms]="socialPlatforms"
                    [metrics]="metrics"
                    (openContent)="openFlyout($event.type, $event.id)"
                ></mkt-content-library>
            </div>

            <!-- ═══ ANALYTICS ═══ -->
            <div *ngIf="!isLoading && activeSection === 'analytics'" class="mktd__section">
                <mkt-analytics-section
                    [metrics]="metrics"
                    [blogs]="blogs"
                    [socialPosts]="socialPosts"
                    [newsletters]="newsletters"
                    [contentTypes]="contentTypes"
                    [isPulling]="isPullingMetrics"
                    (openContent)="openFlyout($event.type, $event.id)"
                    (pullMetrics)="onPullMetrics()"
                ></mkt-analytics-section>
            </div>

            <!-- ═══ SOCIAL QUEUE ═══ -->
            <div *ngIf="!isLoading && activeSection === 'social-queue'" class="mktd__section">
                <mkt-social-queue-section
                    [blogs]="blogs"
                    [socialPosts]="socialPosts"
                    [contentStatuses]="contentStatuses"
                    [companyId]="defaultCompanyId"
                    (contentSaved)="onContentSaved()"
                ></mkt-social-queue-section>
            </div>

        </main>

        <!-- ═══ FLYOUT PANEL ═══ -->
        <aside class="mktd__flyout" [class.mktd__flyout--open]="flyout.open">
            <mkt-blog-detail-panel
                *ngIf="flyout.blogId && flyoutBlog"
                [blog]="flyoutBlog"
                (close)="closeFlyout()"
                (blogSaved)="onContentSaved()"
                (statusChange)="onStatusChange({ contentId: $event.blogId, newStatus: $event.newStatus })"
                (deleteBlog)="onDeleteBlog($event)"
            ></mkt-blog-detail-panel>

            <mkt-social-post-detail-panel
                *ngIf="flyout.socialPostId && flyoutSocialPost"
                [post]="flyoutSocialPost"
                [contentStatuses]="contentStatuses"
                [socialPlatforms]="socialPlatforms"
                [channelConfigs]="channelConfigs"
                (close)="closeFlyout()"
                (postSaved)="onContentSaved()"
                (statusChange)="onStatusChange({ contentId: $event.postId, newStatus: $event.newStatus })"
                (deletePost)="onDeleteSocialPost($event)"
                (publishPost)="onPublishSocialPost($event)"
                (schedulePost)="onScheduleSocialPost($event)"
                (openBlog)="openFlyout('blog', $event)"
            ></mkt-social-post-detail-panel>

            <mkt-newsletter-detail-panel
                *ngIf="flyout.newsletterId && flyoutNewsletter"
                [newsletter]="flyoutNewsletter"
                [contentStatuses]="contentStatuses"
                (close)="closeFlyout()"
            ></mkt-newsletter-detail-panel>
        </aside>
    </div>

    <!-- ═══ TOAST NOTIFICATIONS ═══ -->
    <div class="mktd__toasts">
        <div *ngFor="let t of toasts" class="mktd__toast" [class]="'mktd__toast--' + t.type">
            <i class="fa-solid" [ngClass]="t.icon"></i>
            <span>{{ t.message }}</span>
        </div>
    </div>
</div>
